import Home from './home'
import viewResults from './viewResults'
import MemberProfile from './memberProfile'
import AddUser from './addUser'
import editMember from './editMember'
import BroadcastMail from './broadcastMail'
import ResetPassword from './resetPassword'
import uploeadResults from './uploeadResults'

export default [
    Home,
    MemberProfile,
    AddUser,
    viewResults,
    editMember,
    BroadcastMail,
    ResetPassword,
    uploeadResults,
]